import { getDefaultClient } from '../../../../client/defaultClient';
import { getWalletAccounts } from '../../getWalletAccounts';
import type { WalletAccount } from '../../walletAccount';

/**
 * Get the primary wallet account.
 * The primary wallet account is the one that was last selected by the user.
 * This information is stored in both unverified and verified wallet accounts.
 * This function consolidates this information to determine which wallet was most recently selected.
 */
export const getPrimaryWalletAccount = (
  client = getDefaultClient()
): WalletAccount | null => {
  const walletAccounts = getWalletAccounts(client);

  const sortedLastSelectedWalletAccounts = walletAccounts
    .filter(
      (
        walletAccount
      ): walletAccount is WalletAccount & { lastSelectedAt: Date } =>
        Boolean(walletAccount.lastSelectedAt)
    )
    .sort((a, b) => b.lastSelectedAt.getTime() - a.lastSelectedAt.getTime());

  if (sortedLastSelectedWalletAccounts.length === 0) {
    return null;
  }

  const [primaryWalletAccount] = sortedLastSelectedWalletAccounts;

  return primaryWalletAccount;
};
